<template>
  <div class="panel panel-default" style="margin-bottom: 10px;">
    <div style="display:flex; flex-direction:row">
      <log-line-icon-container :log-line="logLine" @toggle-sticky="$emit('toggle-sticky')"></log-line-icon-container>

      <div style="flex: 5; padding: 0 10px;">
        <log-line-headline-container
            :log-line="logLine"
            @edit="$emit('edit')"
            @postpone="$emit('postpone')"
            @resolve="$emit('resolve')"
        ></log-line-headline-container>

        <div style="padding: 10px 0">
          <log-line-content :logLine="logLine"></log-line-content>
        </div>

        <log-line-footer-container :log-line="logLine"></log-line-footer-container>
      </div>
    </div>
  </div>
</template>

<script>
import LogLineContent from '@/components/LogLine/LogLineContent'
import LogLineFooterContainer from '@/components/LogLine/LogLineFooterContainer'
import LogLineHeadlineContainer from '@/components/LogLine/LogLineHeadlineContainer'
import LogLineIconContainer from '@/components/LogLine/LogLineIconContainer'

export default {
  components: {LogLineContent, LogLineFooterContainer, LogLineHeadlineContainer, LogLineIconContainer},

  model: {
    prop: 'logLine'
  },

  props: ['logLine'],
}
</script>
